import axios from '../axios'

const endpoint = 'api/auth/notification-alerts'

export const getNotificationAlerts = async () => (await axios.get(endpoint)).data
export const updateNotificationAlerts = async (preferences) =>
    (await axios.put(endpoint, preferences)).data
